module.exports = __webpack_public_path__ + "img/message-phone.a6c71056.png";